import styled from "styled-components";

export const StyledButton = styled("button")<{ color?: string }>`
  background: ${(p) => p.color || "#C14F31"};
  color: ${(p) => (p.color ? "#2E186A" : "#fff")};
  font-size: 1.2rem;
  font-weight: 400;
  width: 100%;
  border: 1px solid #C14F31;
  border-radius: 6px;
  padding-right: 10px;
  padding-left: 10px;
  height: 57px;
  cursor: pointer;
  max-width: 220px;
  white-space: nowrap;
  transition: all 0.3s ease-in-out;
  box-shadow: 0 16px 30px rgb(23 31 114 / 20%);

  &:hover,
  &:active,
  &:focus {
    color: #fff;
    border: 1px solid #F1A447;
    background-color: #F1A447;
  }
`;
